/* import __COLOCATED_TEMPLATE__ from './category.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./category.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());